/*eslint compat/compat: "warn"*/
'use strict';

const cookies = require('js-cookie');
const date = require('../util/date');
const isEmpty = require('lodash/isEmpty');
const isPlainObject = require('lodash/isPlainObject');
const merge = require('lodash/merge');
const get = require('lodash/get');

// Settings for use later
const settings = {
    cookieName: '_rtc_uut',
    cookieExpiry: 365, // number of days cookie will be valid for

    cookiePath: '/',
    cookieDomain: '.' + window.location.hostname.split('.').slice(1).join('.'),
    personalisedSelector: '.personalised',
    personalisedClass: 'personalised',
    constituencyCookieName: '_bo_memberships',
};

// Are we developing?
const is_developing = get(window, 'is_developing', false);

// Store todays date for reference later
const now = date.moment();

// We don't want to double update, so grab scorecard
// once and keep a reference
let unknownScorecardCache = null;

function init() {
    // is_developing && console.groupCollapsed('Debug: UUS');

    // Update the scorecard
    updateUnknownScoreCard();

    // Show personalised content
    // showPersonalisedContent();
}

function getUnknownScoreCard() {
    // Return cache if exists
    if (unknownScorecardCache) {
        return unknownScorecardCache;
    }

    // Grab scorecard from cookie
    let unknownScorecard = cookies.get(settings.cookieName);

    // Try to parse scroecard if it's not null
    if (!isEmpty(unknownScorecard)) {
        try {
            unknownScorecard = JSON.parse(unknownScorecard);
        } catch (e) {
            unknownScorecard = null;
        }
    }

    // Create a new scorecard if one can't be found
    if (isEmpty(unknownScorecard) || !isPlainObject(unknownScorecard)) {
        const landingPageGroup = get(window, 'LandingPageGroup', 'Home');

        unknownScorecard = {
            last_visit_date: now.format(),
            recency_online_visits: 0,
            number_online_visits: 0,
            landing_page_group: landingPageGroup,
            last_viewed_page: null,
            scorecard_last_updated: null,
            keywords: {},
        };
    }

    // Update cache for future
    unknownScorecardCache = unknownScorecard;

    // Return
    return unknownScorecard;
}

function updateUnknownScoreCard() {
    // Grab the scorecard
    let unknownScorecard = getUnknownScoreCard();

    // is_developing && console.log('original scorecard', unknownScorecard);

    // Grab last visit date
    const lastVisitDate = date.moment(unknownScorecard.last_visit_date);

    // Calculate difference
    const days = now.diff(lastVisitDate, 'days');

    // Work out the recency visits
    let recencyOnlineVisits = null;

    if (days < 1) {
        recencyOnlineVisits = 100;
    } else if (days >= 364) {
        recencyOnlineVisits = 1;
    } else {
        recencyOnlineVisits = Math.round((365 - days) / 365 * 100);
    }

    // Update total visits
    let numberOnlineVisits = parseInt(unknownScorecard.number_online_visits, 10);
    let currentPathName = document.location.pathname.replace(/\/+$/, '');   // Trim any trailing slashes

    // Only increment the visits if the user has not refreshed the page
    if (currentPathName !== unknownScorecard.last_viewed_page || numberOnlineVisits === 0) {
        numberOnlineVisits++;
    }

    // Grab the page keywords
    let pageKeywords = get(window, 'Keywords', []);

    // And the user keywords
    let userKeywords = get(unknownScorecard, 'keywords', {});

    // Loop through page keywords
    pageKeywords.forEach(keyword => {
        // Grab the ID
        const id = keyword.keyword_id;

        // Find it in user keywords
        let userKeyword = get(userKeywords, id, null);

        if (!userKeyword) {
            userKeywords[ id ] = 1;
        } else {
            // Grab the current value
            const currentScore = parseInt(userKeywords[id]);

            // Update the score
            userKeywords[id] = currentScore + 1;
        }
    });

    // Update the scroecard
    unknownScorecard = merge(unknownScorecard, {
        last_visit_date: now.format(),
        recency_online_visits: recencyOnlineVisits,
        number_online_visits: numberOnlineVisits,
        scorecard_last_updated: now.format(),
        last_viewed_page: currentPathName,
        keywords: userKeywords,
    });

    // Persist the scorecard
    cookies.set(settings.cookieName, JSON.stringify(unknownScorecard), {
        expires: settings.cookieExpiry,
        path: settings.cookiePath,
        domain: settings.cookieDomain
    });

    // is_developing && console.log('updated scorecard', unknownScorecard);
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./modules/personalisation.js